import { StateType } from 'src/redux/reducers';
import { UserProfileStateType } from '@redux/reducers/userProfile.reducer';

export const userProfileSelector = ({ userProfile }: StateType): UserProfileStateType =>
  userProfile;
